import { ROUTE_SCHEDULES } from './constants'

const SchedulesPage = () => import(/* webpackChunkName: "schedules-list" */ './views/SchedulesPage')

export default [{
  path: '/agendamentos',
  name: ROUTE_SCHEDULES,
  component: SchedulesPage
}]
